/*
 * SPDX-FileCopyrightText: 2020 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: GPL-3.0-or-later
 */
import ScopedStorage from "./ScopedStorage.js";
import StorageBuilder from "./StorageBuilder.js";
/**
 * Get the storage builder for an app
 *
 * @param appId App ID to scope storage
 */
export function getBuilder(appId) {
    return new StorageBuilder(appId);
}
/**
 * Clear values from storage
 *
 * @param storage The storage to clear
 * @param pred Callback to check if value should be cleared
 */
function clearStorage(storage, pred) {
    Object.keys(storage)
        .filter((k) => pred ? pred(k) : true)
        .map(storage.removeItem.bind(storage));
}
/**
 * Clear all values from all storages
 */
export function clearAll() {
    const storages = [
        window.sessionStorage,
        window.localStorage,
    ];
    storages.map((s) => clearStorage(s));
}
/**
 * Clear ony non persistent values
 */
export function clearNonPersistent() {
    const storages = [
        window.sessionStorage,
        window.localStorage,
    ];
    storages.map((s) => clearStorage(s, (k) => !k.startsWith(ScopedStorage.GLOBAL_SCOPE_PERSISTENT)));
}
